import { UnreconciledTitles } from '@/core/domain/financial/Boletos/Boletos.types';
import formatterPrice from '@/utils/number/formatterPrice';
import { Collapse, Descriptions } from 'antd';
import DescriptionsItem from 'antd/lib/descriptions/Item';

interface Props {
  unreconciledTitles: UnreconciledTitles[];
}

export default function UnreconciledTitlesCollapsePanelData({
  unreconciledTitles,
}: Props) {
  return (
    <Collapse accordion>
      {unreconciledTitles?.map((unreconciledTitle, index) => (
        <Collapse.Panel
          header={`Código do movimento: ${unreconciledTitle.movementCode}`}
          key={index.toString()}
        >
          <Descriptions column={1}>
            <DescriptionsItem
              label="Códigos de ocorrência"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {unreconciledTitle.occurrenceCodes.join(', ')}
            </DescriptionsItem>
          </Descriptions>

          {!!unreconciledTitle.occurrences?.length && (
            <Collapse accordion style={{ marginBottom: 12 }}>
              <Collapse.Panel header={<strong>Ocorrências</strong>} key="1">
                {unreconciledTitle.occurrences.map((ocurrence) => (
                  <p>{ocurrence}</p>
                ))}
              </Collapse.Panel>
            </Collapse>
          )}

          <Descriptions column={1}>
            <DescriptionsItem
              label="Titulo nosso número"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {unreconciledTitle.titleOurNumber ?? '-'}
            </DescriptionsItem>

            <DescriptionsItem
              label="Titulo nosso número original"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {unreconciledTitle.titleOurOriginalNumber ?? '-'}
            </DescriptionsItem>

            <DescriptionsItem
              label="Titulo data vencimento"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {unreconciledTitle.titleDueDate ?? '-'}
            </DescriptionsItem>

            <DescriptionsItem
              label="Pagamento valor pago"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {formatterPrice(unreconciledTitle.paymentAmountPaid)}
            </DescriptionsItem>

            <DescriptionsItem
              label="Pagamento valor credito"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {formatterPrice(unreconciledTitle.paymentCreditValue)}
            </DescriptionsItem>

            <DescriptionsItem
              label="Pagamento valor taxa Cobranca"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {formatterPrice(unreconciledTitle.paymentAmountChargeFee)}
            </DescriptionsItem>

            <DescriptionsItem
              label="Pagamento valor acrescimos"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {formatterPrice(unreconciledTitle.paymentAdditionalValue)}
            </DescriptionsItem>

            <DescriptionsItem
              label="Pagamento data"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {unreconciledTitle.paymentDate ?? '-'}
            </DescriptionsItem>

            <DescriptionsItem
              label="Pagamento data credito"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {unreconciledTitle.paymentDateCredit ?? '-'}
            </DescriptionsItem>

            <DescriptionsItem
              label="Pagamento realizado?"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {unreconciledTitle.paymentMade ? 'Sim' : 'Não'}
            </DescriptionsItem>

            <DescriptionsItem
              label="Pagamento valor outros creditos"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {formatterPrice(unreconciledTitle.paymentAmountOtherCredits)}
            </DescriptionsItem>

            <DescriptionsItem
              label="Titulo numero documento"
              contentStyle={{ fontWeight: 'bold' }}
            >
              {unreconciledTitle.titleDocumentNumber ?? '-'}
            </DescriptionsItem>
          </Descriptions>
        </Collapse.Panel>
      ))}
    </Collapse>
  );
}
